<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          to="/add-colis"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
        >
          Nouveau Colis
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-11 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success-subtle fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          @click="exportColis()"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>

      <div class="mt-10 mt-lg-0">
        <form class="search-box position-relative" @submit.prevent="filterList">
          <input
            v-model="searchTerm"
            type="text"
            @input="filterList"
            class="form-control shadow-none text-black rounded-pill border ps-40"
            placeholder="Chercher par code ou nom..."
            style="min-width: 300px; height: 45px; background: #f8f9fa"
          />
          <i
            class="flaticon-search-interface-symbol position-absolute start-0 top-50 translate-middle-y ms-15 text-muted"
          ></i>
        </form>
      </div>
    </div>
    <!-- FILTERS -->
    <div class="row g-3 p-15 p-sm-20 p-md-25">
      <!-- Date Range -->
      <div class="col-md-3 position-relative">
        <label class="form-label fw-semibold">Date</label>

        <div
          class="d-flex border rounded bg-white"
          @click="showCalendarBox = !showCalendarBox"
          style="cursor: pointer; height: 42px"
        >
          <div
            class="bg-light d-flex align-items-center justify-content-center border-end"
            style="width: 45px"
          >
            <i class="flaticon-calendar text-muted"></i>
          </div>
          <div
            class="flex-grow-1 d-flex align-items-center px-3 text-secondary"
            style="font-size: 0.9rem"
          >
            {{ confirmedDate[0].format("MM/DD/YYYY") }} -
            {{ confirmedDate[1].format("MM/DD/YYYY") }}
          </div>
        </div>

        <div
          v-if="showCalendarBox"
          @click.stop
          class="position-absolute start-0 mt-1 bg-white border shadow-lg rounded overflow-hidden"
          style="z-index: 1050; display: flex; flex-direction: column"
        >
          <div class="d-flex">
            <div class="border-end" style="width: 180px; background: #fff">
              <div class="list-group list-group-flush">
                <button
                  v-for="p in presets"
                  :key="p.label"
                  @click="handlePresetClick(p)"
                  class="list-group-item list-group-item-action border-0 py-2 px-3 text-start"
                  :class="
                    activePreset === p.label
                      ? 'active-blue'
                      : 'text-primary-link'
                  "
                >
                  {{ p.label }}
                </button>
              </div>
            </div>

            <div
              v-show="activePreset === 'Custom Range'"
              class="calendar-section bg-white"
              style="
                min-width: 600px;
                min-height: 300px;
                display: block !important;
              "
            >
              <MyDateRangePicker
                v-model="tempSelectedDate"
                :enableSecondCalendar="true"
              />
            </div>
          </div>

          <div
            v-if="activePreset === 'Custom Range'"
            class="border-top p-2 d-flex justify-content-between align-items-center bg-light"
            style="min-width: 100%"
          >
            <span class="text-muted small ps-2">
              {{ tempSelectedDate[0]?.format("MM/DD/YYYY") }} -
              {{ tempSelectedDate[1]?.format("MM/DD/YYYY") }}
            </span>
            <div>
              <button
                class="btn btn-sm fw-bold me-3 text-dark"
                @click="showCalendarBox = false"
              >
                Cancel
              </button>
              <button
                class="btn btn-sm px-4 fw-bold text-white"
                style="background-color: #2c3e8c"
                @click="applyCustomRange"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Ville -->
      <div class="col-md-3">
        <label class="form-label fw-semibold">Ville</label>
        <v-select
          v-model="city_filter"
          label="name"
          :options="citiesList"
          class="filter-select"
        />
      </div>

      <!-- État -->
      <div class="col-md-3">
        <label class="form-label fw-semibold">État</label>
        <v-select
          v-model="etat_filter"
          label="name"
          :options="etatList"
          class="filter-select"
        />
      </div>

      <!-- Status -->
      <div class="col-md-3">
        <label class="form-label fw-semibold">Status</label>
        <v-select
          v-model="status_filter"
          label="name"
          :options="status"
          class="filter-select"
        />
      </div>

      <!-- <div class="col-md-6">
        <div class="position-relative">
          <input
            type="text"
            class="form-control ps-5"
            v-model="searchTerm"
            @input="handleInput"
          />
          <i
            class="flaticon-search-interface-symbol position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
          ></i>
        </div>
      </div> -->
      <div class="col-12 text-md-end">
        <button class="btn btn-primary px-4 me-2" @click="filterList">
          <i class="flaticon-filter me-1"></i> Filtrer
        </button>

        <button class="btn btn-outline-secondary px-4" @click="removeFilter">
          <i class="flaticon-refresh me-1"></i> Annuler
        </button>
      </div>
    </div>

    <!-- SEARCH + ACTIONS -->

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="d-flex align-items-center mb-20">
        <label class="me-2 text-paragraph fw-medium">Afficher :</label>
        <select
          class="form-select form-select-sm w-auto"
          v-model="filter.per_page"
          @change="changePerPage"
        >
          <option :value="10">10</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="500">500</option>
        </select>
        <span class="ms-2 text-paragraph">lignes</span>
      </div>

      <div class="table-scroll-outer">
        <div class="table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Dernière mise à jour
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Destinataire
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Etat
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ville
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prix
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ACTIONS
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                BONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <div class="d-flex align-items-center">
                  <h6 v-if="row.replace === 1" class="text-warning">
                    {{ row.code }}
                    <i class="ph ph-repeat"></i>
                  </h6>
                  <h6 v-else-if="row.partial === 1" class="text-info">
                    {{ row.code }}
                    <i class="ph ph-arrows-down-up"></i>
                  </h6>
                  <h6 v-else>
                    {{ row.code }}
                  </h6>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(row.updated_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p class="text-nowrap">
                  <b>{{ row.receiver }}</b> <br />
                  <b>{{ oldPhone(row.phone) }}</b> <br />
                </p>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  :class="`badge text-outline-${resolveUserStatusVariant(
                    row.situation
                  )}`"
                >
                  {{ resolveStatuParcel(row.situation) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': getBadgeConfig(row).color }"
                >
                  {{ getBadgeConfig(row).text }}
                  <template v-if="getBadgeConfig(row).date">
                    <br />{{ getBadgeConfig(row).date }}
                  </template>
                  <template v-if="getBadgeConfig(row).comment">
                    <br />{{ getBadgeConfig(row).comment }}
                  </template>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.city_name }}</b>
                <!-- <br />
                <p v-if="row.quartier && row.quartier.name">
                  {{ row.quartier.name }}
                </p> -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.price }} </b>Dhs<br />
                <p style="word-wrap: break-word; width: 50%">
                  {{ row.product_nature }}
                </p>
              </td>

              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- Historique -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetailSuivi(row)"
                      >
                        <i
                          class="flaticon-clock lh-1 me-8 position-relative top-1"
                        ></i>
                        Historique
                      </button>
                    </li>

                    <!-- Infos -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </button>
                    </li>

                    <!-- Edit -->
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="claimParcel(row)"
                      >
                        <i
                          class="flaticon-communication lh-1 me-8 position-relative top-1"
                        ></i>
                        Réclamer
                      </a>
                    </li>

                    <!-- WhatsApp Share -->
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        target="_blank"
                        :href="`https://api.whatsapp.com/send?phone=${SubstrPhone(
                          row.phone
                        )}&text=Client : ${row.phone} Téléphone : ${
                          row.customer_phone
                        } Code d'envoi : ${row.code} Destinataire : ${
                          row.receiver
                        } Téléphone : ${row.phone} Ville : ${
                          row.city_name
                        } Adresse : ${row.address} Commentaire : ${
                          row.note
                        } Produit : ${row.product_nature} Crbt : ${
                          row.price
                        } DH`"
                      >
                        <i
                          class="ph ph-whatsapp-logo lh-1 me-8 position-relative top-1"
                        ></i>
                        WhatsApp
                      </a>
                    </li>
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="callPhone(row.phone)"
                      >
                        <i
                          class="ph ph-phone lh-1 me-8 position-relative top-1"
                        ></i>
                        Appeler destinaire
                      </button>
                    </li>

                    <!-- Conditional Delete -->
                    <li v-if="row.status === 'NEW_PARCEL'">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="Destroy_Coli(row)"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Supprimer
                      </a>
                    </li>

                    <!-- Force Delete -->

                    <!-- Update -->
                    <li v-if="row.status == 'NEW_PARCEL'">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="showUpdate(row)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                  </ul>
                </div>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-show="showRefs">
                  <ul class="s2">
                    <li v-if="row.delivery_note != 0" class="circle">
                      <a
                        style="cursor: pointer"
                        target="_blank"
                        @click="voirItem(row.delivery_note, '1')"
                        >{{ row.delivery_note_ref }}
                      </a>
                    </li>

                    <li v-if="row.delivery_note != 0" class="circle">
                      <a
                        style="cursor: pointer"
                        target="_blank"
                        @click="voirItem(row.delivery_note, '0')"
                        >{{ row.delivery_note_ref }}
                      </a>
                    </li>

                    <li v-if="row.rn_c_ref != 0" class="circle">
                      <a
                        @click="voirItem(row.rn_c, '2')"
                        style="cursor: pointer"
                        >{{ row.rn_c_ref }}
                      </a>
                    </li>

                    <li
                      v-if="
                        row.bons && row.bons.inv && row.bons.inv.length != 0
                      "
                      class="circle"
                    >
                      <a
                        v-for="(invoice, index) in row.bons.inv"
                        :key="index"
                        @click="voirItem(invoice.invoice_id, '3')"
                        style="cursor: pointer"
                        >{{ invoice.invoice_code }}
                      </a>
                    </li>
                  </ul>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
      >
        <div class="d-flex align-items-center mb-3 mb-md-0">
          <label class="me-2 text-paragraph fw-medium">Afficher :</label>
          <select
            class="form-select form-select-sm w-auto"
            v-model="filter.per_page"
            @change="changePerPage"
          >
            <option :value="10">10</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
            <option :value="500">500</option>
          </select>
          <span class="ms-2 text-paragraph">lignes</span>
        </div>

        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">
            {{ (filter.current_page - 1) * filter.per_page + 1 }}
          </span>
          –
          <span class="fw-bold">
            {{ Math.min(filter.current_page * filter.per_page, filter.total) }}
          </span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="displayedPages[0] > 1" class="page-item">
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(1)"
                >1</a
              >
            </li>
            <li v-if="displayedPages[0] > 2" class="page-item disabled">
              <span class="page-link">...</span>
            </li>

            <li v-for="page in displayedPages" :key="page" class="page-item">
              <a
                href="javascript:void(0)"
                class="page-link"
                :class="{ active: filter.current_page === page }"
                @click="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <li
              v-if="
                displayedPages[displayedPages.length - 1] < filter.last_page - 1
              "
              class="page-item disabled"
            >
              <span class="page-link">...</span>
            </li>
            <li
              v-if="
                displayedPages[displayedPages.length - 1] < filter.last_page
              "
              class="page-item"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(filter.last_page)"
              >
                {{ filter.last_page }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Filter -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Filtrer</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form class="row">
            <!-- Magasin -->

            <!-- Zone -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Zone:</label>
                <v-select
                  class="custom-select-height"
                  v-model="zone_filter"
                  label="name"
                  :options="zonesList"
                />
              </div>
            </div>

            <!-- Ville -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Ville:</label>
                <v-select
                  class="custom-select-height"
                  v-model="city_filter"
                  label="name"
                  :options="citiesList"
                />
              </div>
            </div>

            <!-- Etat -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Etat:</label>
                <v-select
                  class="custom-select-height"
                  v-model="etat_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="etatList"
                />
              </div>
            </div>

            <!-- Status -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Status:</label>
                <v-select
                  class="custom-select-height"
                  v-model="status_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="status"
                />
              </div>
            </div>

            <!-- Par Date de -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Par Date de:</label>
                <select v-model="type_date_filter" class="form-control">
                  <option value="ADD_DATE">Date de création</option>
                  <option value="LAST_UPDATE">Dernière Mise à jour</option>
                  <option value="PICKED_DATE">Date de ramassage</option>
                  <option value="SENT_DATE">Date d'expédition</option>
                  <option value="DELIVERY_DATE">Date de livraison</option>
                  <option value="POSTPONED_DATE">Date reportée</option>
                </select>
              </div>
            </div>

            <!-- Ajouté Au BPL -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Ajouté Au BPL:</label>
                <select v-model="add_bp_filter" class="form-control">
                  <option value="">Tous</option>
                  <option value="0">Non Ajouté Au BPL</option>
                  <option value="1">Ajouté Au BPL et Non Payé</option>
                </select>
              </div>
            </div>

            <!-- Afficher Réf -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Afficher Réf:</label>
                <select
                  v-model="ref_filter"
                  class="form-control"
                  @change="showRefsEdit"
                >
                  <option value="">Tous</option>
                  <option value="1">Afficher les Ref</option>
                  <option value="0">Ne pas afficher les Refs</option>
                </select>
              </div>
            </div>

            <!-- Prix 0DH (with permission) -->
            <template>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label>Prix 0DH:</label>
                  <select v-model="price_filter" class="form-control">
                    <option value="">Tous</option>
                    <option value="1">Oui</option>
                    <option value="0">Non</option>
                  </select>
                </div>
              </div>
            </template>

            <!-- Par Date -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Par Date:</label>
                <!-- Add your datepicker here -->
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <!-- <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button> -->
          <button type="button" @click="filterList" class="btn btn-primary">
            Annuler
          </button>
          <button type="button" @click="removeFilter" class="btn btn-warning">
            Appliquer
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- exported todaycolis modal -->
  <div class="modal fade" id="modalExortToday" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Colis reportés pour aujourd'hui</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <exported-today />
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Status Update Modal using Bootstrap -->
  <div
    class="modal fade"
    id="modal_detail_suivi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Historique Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <HistoryColis v-if="colisId" :colisId="colisId" :isOpen="isOpen" />
        </div>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Parcel Modal using Bootstrap -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRecords"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Fees Modal using Bootstrap -->
  <div class="modal fade" id="modal_fees_edit" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier les frais</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body"></div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { nextTick, onMounted, onUnmounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import HistoryColis from "@/components/Colis/HistoryColis.vue";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import DetailsColis from "@/components/Colis/DetailsColis.vue";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { computed } from "vue";

export default {
  name: "ColisList",
  components: {
    HistoryColis,
    DetailsColis,
    UpdateParcel,
    MyDateRangePicker,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const leadPlaceholder = "Select Lead Date";
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const direction = ref(true); // if you use RTL boolean; adjust to your prop type
    const isLoader = ref(false);
    const ExportToday = ref(null);
    const countExportToday = ref(0);

    const minDate = ref(
      moment(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        )
      ).format("YYYY-MM-DD")
    );

    const columns = [
      { label: "Code d'envoi", field: "code" },
      { label: "Dernière mise à jour", field: "updated_at" },
      { label: "Destinataire", field: "receiver" },
      { label: "Magasin", field: "magasin_m" },
      { label: "Etat", field: "situation" },
      { label: "Status", field: "status" },
      { label: "Ville", field: "city_name" },
      { label: "Prix", field: "price" },
      { label: "Action", field: "action" },
      { label: "", field: "bn" },
    ];

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchCity: "",
      searchEtat: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchCode: "",
      searchTerm: "",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const zone_filter = ref({ id: "", name: "" });
    const client_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref({ id: "", name: "", code: "" });

    const etat_filter = ref("");
    const type_date_filter = ref("");
    const add_bp_filter = ref("");
    const ref_filter = ref("");
    const email_filter = ref("");
    const price_filter = ref("");
    const searchTerm = ref("");

    const coliDetails = ref<any>({});
    const statutColi = ref<any>({});
    const commentStatu = ref("");
    const date_retour = ref("");
    const statuColisID = ref(0);

    const formStatus = reactive({
      id: 0,
      status: "",
      status_id: 0,
      comment: "",
    });

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);
    const StatusList2 = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const zonesList = ref<Status[]>([]);
    const citiesList = ref<Status[]>([]);
    const livreurList = ref<Status[]>([]);
    const etatList = ref(["Tous", "Non Payé", "Payé", "Facturé"]);

    function convert(date) {
      // example: to YYYY-MM-DD (adapt to your backend)
      const d = new Date(date);
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    }

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    const changePerPage = () => {
      filter.current_page = 1; // reset to first page when changing limit
      getRecords();
    };
    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",
        searchCity: filter.searchCity || "",
        searchEtat: filter.searchEtat || "",
        searchStatut: filter.searchStatut || "",
        searchSDate: filter.searchSDate || "",
        searchEDate: filter.searchEDate || "",
        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/client/all_colis_list?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
      try {
        const response = await api.get("/api/auth/AllStatus");
        if (response && response.data) {
          status.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }

      // try {
      //   const response = await api.get(`/api/auth/ListZone`);
      //   if (response && response.data) {
      //     zonesList.value = response.data;
      //     zonesList.value.unshift({ code: "0", name: "Tous" });
      //   }
      // } catch (error) {
      //   console.error("Error fetching user data:", error);
      // }

      try {
        const { data } = await api.get(`/api/auth/citiesList`);

        if (Array.isArray(data)) {
          citiesList.value = data;

          // Évite les doublons
          if (
            !citiesList.value.some(
              (city) => city.code === "0" && city.name === "Tous"
            )
          ) {
            citiesList.value.unshift({ code: "0", name: "Tous" });
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des villes :", error);
        // showToast("Impossible de charger la liste des villes", "error")
      }

      try {
        const response = await api.get(`/api/auth/AllStatus`);
        if (response && response.data) {
          StatusList2.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })

        countExportToday.value = data.exported;
      } finally {
        isLoader.value = false;
      }
    }

    function filterList() {
      console.log("filter here");
      console.log(tempSelectedDate)
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";

      // Check if tempSelectedDate is an array and contains at least a start date
      if (tempSelectedDate.value && tempSelectedDate.value.length === 2) {
        // Force fresh formatting from the current reactive value
        const s = tempSelectedDate.value[0];
        const e = tempSelectedDate.value[1];

        filter.searchSDate = s && s.isValid() ? s.format("YYYY-MM-DD") : "";
        filter.searchEDate = e && e.isValid() ? e.format("YYYY-MM-DD") : "";
      }

      filter.searchTerm = searchTerm.value || "";

      filter.current_page = 1;
      getRecords();
    }

    async function exportColis() {
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";

      //   filter.searchSDate = myInput.value?.dateRange?.start
      //     ? convert(myInput.value.dateRange.start)
      //     : "";
      //   filter.searchEDate = myInput.value?.dateRange?.end
      //     ? convert(myInput.value.dateRange.end)
      //     : "";

      filter.searchTerm = searchTerm.value || "";

      try {
        const res = await api.get(
          `/api/auth/client/ExportColis?searchTerm=${filter.searchTerm}&searchCity=${filter.searchCity}&searchEtat=${filter.searchEtat}&searchStatut=${filter.searchStatut}&searchSDate=${filter.searchSDate}&searchEDate=${filter.searchEDate}`,
          { responseType: "arraybuffer" }
        );

        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ExportColis.xlsx";
        fileLink.click();
      } catch (error) {
        if (error.response) {
          // Erreur serveur (ex: 500)
          console.error(
            "Erreur serveur :",
            error.response.status,
            error.response.data
          );
          // Exemple toast ou showToaste
          // showToast("Une erreur serveur est survenue lors de l’export (500)", "error");
          showToast(
            "Une erreur serveur est survenue lors de l’export.",
            "error"
          );
        } else if (error.request) {
          // Pas de réponse du serveur
          console.error("Aucune réponse du serveur :", error.request);
          showToast(
            "Impossible de contacter le serveur. Vérifiez votre connexion.",
            "error"
          );
        } else {
          // Erreur autre (ex: code JS)
          console.error("Erreur lors de la requête :", error.message);
          showToast("Une erreur inattendue est survenue.", "error");
        }
      }
    }

    function removeFilter() {
      // reset users filters

      filter.searchCity = "";
      filter.searchEtat = "";
      filter.searchStatut = "";

      filter.searchSDate = "";
      filter.searchEDate = "";

      filter.searchTerm = "";
      filter.current_page = 1;

      // reset local UI models
      etat_filter.value = "";
      add_bp_filter.value = "";
      ref_filter.value = "";
      email_filter.value = "";
      type_date_filter.value = "";
      price_filter.value = "";
      searchTerm.value = "";

      zone_filter.value = { id: "", name: "" };
      client_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      city_filter.value = { id: "", name: "" };
      status_filter.value = { id: "", name: "", code: "" };
      tempSelectedDate.value = [];
      // clear date range picker model
      //   if (!myInput.value) myInput.value = { dateRange: {} }
      //   myInput.value.dateRange = {}

      getRecords();
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }
    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }
      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    function formatReported(row: any) {
      return removeHours(row.reported_date);
    }

    // Decide what to show in badge
    function getBadgeConfig(row: any) {
      // IN_PROGRESS with secondary status
       if(!row.statut){
        return {
           text: row.status,
          color: "#fff",
        }
       }
      if (
        row.status === "IN_PROGRESS" &&
        row.status_second &&
        getStatusName(row.status_second)
      ) {
        if (
          ["POSTPONED", "PROGRAMED", "POSTPONED_TODAY"].includes(
            row.status_second
          )
        ) {
          return {
            text: getStatusName(row.status_second),
            date: formatReported(row),
            color: reported(row.reported_date)
              ? "#E50A0A"
              : getStatusColor(row.status_second),
          };
        }
        return {
          text: getStatusName(row.status_second),
          color: getStatusColor(row.status_second),
        };
      }

      // RETURNED but not REFUSE
      if (
        row.status === "RETURNED" &&
        (!row.status_second || row.status_second !== "REFUSE") &&
        row.last_statut_comment
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `${row.statut.s_name} Endommagé`
              : row.statut.s_name,
          comment: row.last_statut_comment,
          color: row.statut.code_color,
        };
      }

      // RETURNED with REFUSE
      if (
        row.status === "RETURNED" &&
        row.status_second === "REFUSE" &&
        getStatusName(row.status_second)
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `Retourné Endommagé - ${getStatusName(row.status_second)}`
              : `Retourné - ${getStatusName(row.status_second)}`,
          comment: row.last_statut_comment,
          color: getStatusColor(row.status_second),
        };
      }

      // Default
      return {
        text:
          row.rn_e && row.rn_e !== 0 && row.status === "RETURNED"
            ? `${row.statut.s_name} Endommagé`
            : row.statut.s_name,
        color: row.statut.code_color,
      };
    }

    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(searchTimeout)
    //   searchTimeout = setTimeout(() => {
    //     filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    const showRefs = ref(true);
    function showRefsEdit() {
      if (ref_filter.value == "1") {
        showRefs.value = true;
      } else {
        showRefs.value = false;
      }
    }

    // Mapping type to endpoint
    const pdfEndpoints = {
      1: "DELPDF",
      0: "TicketsPDF",
      2: "ReturnPDF",
      3: "InvoicePdf",
    };

    async function voirItem(item, type) {
      const endpoint = pdfEndpoints[type];
      if (!endpoint) {
        console.warn(`PDF type "${type}" non géré`);
        return;
      }

      try {
        const res = await api.get(`/api/auth/client/${endpoint}/${item}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
        // Optional: download automatically
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = `${item}.pdf`;
        // link.click();
      } catch (error) {
        console.error(error);
        showToast("Erreur lors du téléchargement du PDF", "error");
      }
    }

    const PriceColis = ref(null);

    // -------------------------------
    // Function to show parcel history
    const colisId = ref(null);
    const isOpen = ref(false);

    async function showDetailSuivi(row) {
      isOpen.value = false;
      colisId.value = null;

      colisId.value = row.id;
      nextTick(() => {
        const modalEl = document.getElementById("modal_detail_suivi");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true;
          modal.show();
        }
      });

      // TODO: Open history modal
    }

    // -------------------------------
    // Function to show parcel info
    async function showDetails(row) {
      coliDetails.value = null;
      isOpen.value = false;

      coliDetails.value = row; // ✅ set data first

      nextTick(() => {
        const modalEl = document.getElementById("modal_detail_colis");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true; // ✅ open modal *after* coliDetails is set
          modal.show();
        }
      });
    }

    // -------------------------------
    // Function to edit parcel
    async function editParcel(row) {
      console.log("Editing parcel:", row);
      // TODO: Open edit modal
    }

    // -------------------------------
    // Function to format phone for WhatsApp
    async function SubstrPhone(phone) {
      // Example: remove first zero and add country code
      return phone.startsWith("0") ? "212" + phone.slice(1) : phone;
    }

    // -------------------------------
    // Delete a parcel
    async function Destroy_Coli(row: any) {
      // console.log("Deleting parcel:", row);
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(
              `/api/auth/client/DeleteColis/${row.id}`
            );
            if (res.data.message === "success") {
              showToast("Colis supprimé avec succès", "success");
              getRecords();
            } else if (res.data.message === "error") {
              showToast("Vous pouvez pas supprimer ce colis", "error");
            }
          } catch (error) {
            showToast("Erreur lors de la suppression du colis", "error");
          }
        }
      });
    }

    // -------------------------------
    const rowUpdate = ref(null);
    // Show update modal
    async function showUpdate(row) {
      console.log("Showing update modal for:", row);
      rowUpdate.value = row;
      const modalEl = document.getElementById("modal_update");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    // -------------------------------
    // Mark parcel as paid
    async function claimParcel(row) {
      console.log("Marking parcel as paid:", row);
      // TODO: Implement payment logic
    }

    // Call phone number
    function callPhone(phone: string) {
      window.open(`tel:${phone}`);
    }

    const debounceTimer = ref<number | undefined>(undefined);

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = window.setTimeout(() => {
        filter.searchTerm = searchTerm.value;
        filter.current_page = 1;
        getRecords();
      }, 500);
    }

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    // const selectedDate = ref(null);

    // const showCalendarBox = ref(false);

    // function showCalendar() {
    //   console.log(selectedDate.value);
    //   showCalendarBox.value = !showCalendarBox.value;
    // }

    // State

    const showCalendarBox = ref(false);
    const activePreset = ref("Depuis le lancement");

    // Input display state
    const confirmedDate = ref([moment("2022-09-30"), moment()]);
    // Temporary state for the picker before clicking "Apply"
    const tempSelectedDate = ref([moment("2022-09-30"), moment()]);

    const presets = [
      { label: "Depuis le lancement", value: [moment("2022-09-30"), moment()] },
      { label: "Aujourdhui", value: [moment(), moment()] },
      {
        label: "Hier",
        value: [moment().subtract(1, "d"), moment().subtract(1, "d")],
      },
      {
        label: "7 derniers jours",
        value: [moment().subtract(6, "d"), moment()],
      },
      {
        label: "30 derniers jours",
        value: [moment().subtract(29, "d"), moment()],
      },
      {
        label: "Ce mois",
        value: [moment().startOf("month"), moment().endOf("month")],
      },
      {
        label: "Le mois dernier",
        value: [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
      { label: "Custom Range", value: null },
    ];

    function handlePresetClick(p) {
      activePreset.value = p.label;
      if (p.value) {
        confirmedDate.value = p.value;
        showCalendarBox.value = false; // Auto-close for fixed presets
      } else {
        // ✅ Custom Range → show calendar
        tempSelectedDate.value = [...confirmedDate.value];
      }
      // If "Custom Range", we stay open to show the calendar
    }

    function applyCustomRange() {
      confirmedDate.value = [...tempSelectedDate.value];
      showCalendarBox.value = false;
    }

    const displayedPages = computed(() => {
      const total = filter.last_page;
      const current = filter.current_page;
      const delta = 2; // Number of pages to show on each side of current
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      range.unshift(1);
      if (current + delta < total - 1) range.push("...");
      if (total > 1) range.push(total);

      return range;
    });

    return {
      leadPlaceholder,
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      oldPhone,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      getBadgeConfig,
      zone_filter,
      client_filter,
      liv_filter,
      city_filter,
      status_filter,
      showRefsEdit,
      showRefs,

      etat_filter,
      type_date_filter,
      add_bp_filter,
      ref_filter,
      email_filter,
      price_filter,
      searchTerm,

      clientList,
      zonesList,
      citiesList,
      livreurList,
      etatList,
      status,

      filterList,
      removeFilter,
      exportColis,
      countExportToday,

      voirItem,
      user,

      PriceColis,
      showDetailSuivi,
      showDetails,
      editParcel,
      SubstrPhone,
      Destroy_Coli,
      showUpdate,
      claimParcel,

      // modals
      minDate,
      statutColi,
      commentStatu,
      date_retour,
      StatusList2,

      colisId,
      isOpen,
      coliDetails,
      getRecords,
      rowUpdate,

      todayDt,
      firstDt,
      // selectedDate,
      // showCalendar,
      // showCalendarBox,
      isLoader,
      changePerPage,
      callPhone,
      handleInput,

      displayedPages,
      handlePresetClick,
      showCalendarBox,
      activePreset,
      tempSelectedDate,
      applyCustomRange,
      presets,
      confirmedDate,
    };
  },
};
</script>
<style scoped>
/* Outer div scrolls horizontally; inner stays overflow:visible so dropdowns aren't clipped */

/* Matching the blue from your image */
.active-blue {
  background-color: #008ecb !important;
  color: white !important;
  font-weight: 500;
}

/* Matching the blue text for inactive links */
.text-primary-link {
  color: #6a71fe !important; /* Adjust shade to match your specific link blue */
  background: transparent;
  font-size: 0.85rem;
}

.list-group-item-action:hover {
  background-color: #f8f9fa;
}

/* Ensure the picker doesn't have internal borders that clash */
.my-date-picker-class {
  border: none !important;
}
</style>